import Ajax from 'js/utils/ajax/ajax.js';

import { ApiUser } from 'src/interfaces/interfaces.generated';

export const createWSUser = (
  shopId: number,
  shopName: string,
  apiUser: ApiUser
): Promise<ApiUser> => Ajax.post(`/useradmin/v1/wsuser/${shopId}/${shopName}`, apiUser);
